import { type UnityRichText } from '@@api/utils/schemas/schemas';
import { RichTextCodec } from '@@plate/serialization/unity';
import { type RootElement } from '@@plate/serialization/unity/groups';

const serializeState = (state: RootElement[]): UnityRichText => {
    const serialized = RichTextCodec.safeEncode(state);

    if (serialized.success) {
        return serialized.data;
    }

    console.error(serialized.error, state);
    throw new Error('Failed to serialize state with Plate.js codec. Details in console.');
};

export default serializeState;
